import { create } from "zustand";

// Zustand store for theme management
const useThemeStore = create((set) => ({
    // Retrieve initial theme from local storage or default to "light"
    currentTheme: window.localStorage.getItem("theme") || "light",

    // Function to switch themes
    themeSwitchHandler: (themeType) => {
        window.localStorage.setItem("theme", themeType);

        document.body.classList.remove("light-theme", "dark-theme");
        document.body.classList.add(themeType === "light" ? "light-theme" : "dark-theme");

        set({ currentTheme: themeType });
    },
}));

export default useThemeStore;